import { getLinkProps } from '~/utils'

export function getEmployeeLinkProps(routes, getLinkPropsConfig) {
  const { userRoute, employeeRoute, isEmployee } = routes
  return getLinkProps(isEmployee ? employeeRoute : userRoute, getLinkPropsConfig)
}
